/*
 * Copyright Huesik (c) 2019.
 */
import store from '../store'

export default {
  alert (message) {
    try {
      if (this._isNative() && window.navigator.hasOwnProperty('notification')) {
        window.navigator.notification.alert(
          message,
          this._alertDismiss,
          '알림',
          '확인'
        )
      } else {
        alert(message)
      }
    } catch (e) {
      alert(message)
    }
  },
  confirm (message) {
    try {
      if (this._isNative()) {
        window.navigator.notification.confirm(
          message,
          this._confirmDismiss,
          '알림',
          ['확인', '취소']
        )
      } else {
        return confirm(message)
      }
    } catch (e) {
      return confirm(message)
    }
  },
  _alertDismiss () {

  },
  _confirmDismiss () {

  },
  _isNative () {
    return store.state.APP.IS_NATIVE
  }
}
